const lsTemplate = (type) => `messaging/${type}/rowsPerPage`;
const LS_TEMPLATE_ROWS = lsTemplate('templates');
const LS_USERS_ROWS = lsTemplate('users');
const LS_LOGS_ROWS = lsTemplate('logs');

/**
 * Construct Vuex 'messaging' module
 *
 * @param {*} services Services object for API access
 * @return {*}
 */
export default function(services) {
  return {
    namespaced: true,
    state: {
      authorities: [],
      authoritiesRequireUpdate: true,
      templatesPagination: {
        rowsPerPage: Number.parseInt(localStorage.getItem(LS_TEMPLATE_ROWS)) || 5
      },
      users: [],
      usersRequireUpdate: true,
      usersPagination: {
        rowsPerPage: Number.parseInt(localStorage.getItem(LS_USERS_ROWS)) || 5
      },
      logsPagination: {
        descending: false,
        rowsPerPage: Number.parseInt(localStorage.getItem(LS_LOGS_ROWS)) || 5
      },
      logsDate: new Date().toISOString().split('T')[0]
    },
    mutations: {
      authorities(state, authorities) {
        state.authorities = authorities;
      },
      authoritiesRequireUpdate(state, requiresUpdate) {
        state.authoritiesRequireUpdate = requiresUpdate;
      },
      templatesPagination(state, pagination) {
        localStorage.setItem(LS_TEMPLATE_ROWS, pagination.rowsPerPage);
        state.templatesPagination = pagination;
      },
      users(state, users) {
        state.users = users;
      },
      usersRequireUpdate(state, requiresUpdate) {
        state.usersRequireUpdate = requiresUpdate;
      },
      usersPagination(state, pagination) {
        localStorage.setItem(LS_USERS_ROWS, pagination.rowsPerPage);
        state.usersPagination = pagination;
      },
      logsPagination(state, pagination) {
        localStorage.setItem(LS_LOGS_ROWS, pagination.rowsPerPage);
        state.logsPagination = pagination;
      },
      logsDate(state, date) {
        state.logsDate = date;
      }
    },
    actions: {
      initializeAuthorities(context, forceUpdate) {
        if (context.state.authoritiesRequireUpdate || forceUpdate) {
          context.commit('authoritiesRequireUpdate', false);
          return services.messaging.get('/authorities')
            .then((res) => context.commit('authorities', res.data.authorities));
        }
      },
      initializeUsers(context, forceUpdate) {
        if (context.state.usersRequireUpdate || forceUpdate) {
          context.commit('usersRequireUpdate', false);
          return services.messaging.get('/config/all')
            .then((res) => context.commit('users', res.data.users));
        }
      },
      resetUsers(context) {
        context.commit('usersRequireUpdate', true);
      }
    }
  };
}
